export default "__VITE_ASSET__3bb7cefa__"